import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';

const AddCategory = (props) => {
  return (
    <>
      <div className="container pb-5 mb-5">
        <div className="row justify-content-center mt-4">
          <div className="col-12">
            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.05)',
                padding: '40px',
                border: '1px solid #eaeaea'
              }}
            >
              <h4 style={{ marginBottom: '30px', fontWeight: '600', color: '#333' }}>
                Product Category
              </h4>
              <div className="row g-4">
                <div className="col-md-4">
                  <label className="form-label text-muted fw-semibold mb-2" style={{ fontSize: '15px' }}>
                    Select Category <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={props.categoryData ? props.categoryData.map(item => ({ label: item.name, value: item.id })) : []}
                    menuPosition="fixed"
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: '10px',
                        border: '1px solid #dcdfe6',
                        fontSize: '16px',
                        padding: '4px',
                        boxShadow: 'none',
                        cursor: 'pointer',
                        '&:hover': { borderColor: '#c0c4cc' }
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                    value={
                      props.categoryData
                        ? props.categoryData.filter(item => item.id == props.addProductData?.category_id).map(item => ({ label: item.name, value: item.id }))[0] || null
                        : null
                    }
                    onChange={(selected) => {
                      const value = selected ? selected.value : "";
                      props.fetchSubCategory(value);
                      if (value && value !== "Select Category") {
                        props.setDone(true);
                        props.fetchBrandData({ category_id: value, sub_category_id: '', third_category_id: '' }, true);
                      } else {
                        props.setDone(false);
                        props.fetchBrandData({ category_id: '', sub_category_id: '', third_category_id: '' }, true);
                      }
                      props.setAddProductData({
                        ...props.addProductData,
                        category_id: value,
                        sub_category_id: '',
                        third_category_id: '',
                        brand_id: ''
                      });
                    }}
                    isClearable
                    placeholder="Select Category"
                  />
                </div>
                {props.subCategoryData == '' ? (
                  <></>
                ) : (
                  <div className="col-md-4">
                    <label className="form-label text-muted fw-semibold mb-2" style={{ fontSize: '15px' }}>
                      Select Sub Category
                    </label>
                    <Select
                      options={props.subCategoryData ? props.subCategoryData.map(item => ({ label: item.name, value: item.id })) : []}
                      menuPosition="fixed"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: '10px',
                          border: '1px solid #dcdfe6',
                          fontSize: '16px',
                          padding: '4px',
                          boxShadow: 'none',
                          cursor: 'pointer',
                          '&:hover': { borderColor: '#c0c4cc' }
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                      value={
                        props.subCategoryData
                          ? props.subCategoryData.filter(item => item.id == props.addProductData?.sub_category_id).map(item => ({ label: item.name, value: item.id }))[0] || null
                          : null
                      }
                      onChange={(selected) => {
                        const value = selected ? selected.value : "";
                        props.fetchLastCategory(value);
                        if (value && value !== "Select Sub Category") {
                          props.setDone(true);
                          props.fetchBrandData({ category_id: props.addProductData?.category_id, sub_category_id: value, third_category_id: '' });
                        } else {
                          props.fetchBrandData({ category_id: props.addProductData?.category_id, sub_category_id: '', third_category_id: '' });
                        }
                        props.setAddProductData({
                          ...props.addProductData,
                          sub_category_id: value,
                          third_category_id: '',
                          brand_id: ''
                        });
                      }}
                      isClearable
                      placeholder="Select Sub Category"
                    />
                  </div>
                )}

                {props.lastCategoryData == '' ? (
                  <></>
                ) : (
                  <div className="col-md-4">
                    <label className="form-label text-muted fw-semibold mb-2" style={{ fontSize: '15px' }}>
                      Select Last Category
                    </label>
                    <Select
                      options={props.lastCategoryData ? props.lastCategoryData.map(item => ({ label: item.name, value: item.id })) : []}
                      menuPosition="fixed"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: '10px',
                          border: '1px solid #dcdfe6',
                          fontSize: '16px',
                          padding: '4px',
                          boxShadow: 'none',
                          cursor: 'pointer',
                          '&:hover': { borderColor: '#c0c4cc' }
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                      value={
                        props.lastCategoryData
                          ? props.lastCategoryData.filter(item => item.id == props.addProductData?.third_category_id).map(item => ({ label: item.name, value: item.id }))[0] || null
                          : null
                      }
                      onChange={(selected) => {
                        const value = selected ? selected.value : "";
                        props.setDone(true);
                        props.setAddProductData({
                          ...props.addProductData,
                          third_category_id: value,
                          brand_id: ''
                        });
                        props.fetchBrandData({
                          category_id: props.addProductData?.category_id,
                          sub_category_id: props.addProductData?.sub_category_id,
                          third_category_id: value
                        });
                      }}
                      isClearable
                      placeholder="Select Last Category"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
